import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  getAvailableSubProductsForFactoring,
  getDocumentsAvailablesForFactoring,
} from '../../../../../../lib/api';
import CompanyBusinessSearcher from '../../../../../../lib/common/CompanyBusinessSearcher';
import GlobalSearcher, {
  Filter,
} from '../../../../../../lib/common/GlobalSearcher';
import RutBusinessSearcher from '../../../../../../lib/common/RutBusinessSearcher';
import CustomButton from '../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions from '../../../../../../lib/designSystem/HeaderWithActions';
import SimulationBanner from '../../../../../../lib/designSystem/SimulationBanner';
import { LightTooltip } from '../../../../../../lib/designSystem/WhiteTooltip';
import { formatMoney } from '../../../../../../lib/functions/utils';
import SimulatorDialog from '../../Factoring/components/Simulator';
import AddDocumentsManually from './components/documentsAdder';
import AddInvoicesManually from './components/invoicesAdder';

const DocumentsSelectorDialog = (props: any) => {
  const {
    open,
    setOpen,
    setSelectedDocuments,
    selectedDocuments,
    setNewOpenShoppingCart,
    business,
    setBusiness,
    subProductSelected,
    setSubProductSelected,
    setSubProduct,
    backwards,
    setBackwards,
    setSuccessOpen,
  } = props;
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<any>([]);
  const [searchedBySubProduct, setSearchedBySubProduct] = useState<any>(false);
  const [documents, setDocuments] = useState<any>([]);
  const [subProducts, setSubProducts] = useState<any>([]);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [createWithoutCreditline, setCreateWithoutCreditline] = useState(false);
  const [openInvoicesAdder, setOpenInvoicesAdder] = useState(false);
  const [openDocumentAdder, setOpenDocumentAdder] = useState<any>(null);
  const [configuration, setConfiguration] = useState<any>(null);
  const [cachedDocuments, setCachedDocuments] = useState<any>([]);
  const [isSimulation, setIsSimulation] = useState(false);
  const [openSimulator, setOpenSimulator] = useState(false);
  const [activeTab, setActiveTab] = useState<'company' | 'rut'>('company');

  // Filters
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [stakeholderIdentifier, setStakeholderIdentifier] = useState('');
  const [stakeholderName, setStakeholderName] = useState('');
  const [enrolledType, setEnrolledType] = useState<any>(null);
  const [folio, setFolio] = useState('');
  const PAGE_SIZE = 10;
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
    total: 0,
    totalPages: 0,
  });

  const generateQuery = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    let query = '';
    if (folio) query += `folio=${folio}&`;
    if (stakeholderIdentifier)
      query += `stakeholderIdentifier=${stakeholderIdentifier}&`;
    if (stakeholderName) query += `stakeholderName=${stakeholderName}&`;
    if (page) query += `page=${page}&pageSize=${pageSize}&`;
    if (startDate) query += `startDate=${startDate}&`;
    if (endDate) query += `endDate=${endDate}`;
    if (selectedDocuments.length)
      query += `selectedDocuments=${selected.join(',')}&`;
    if (enrolledType && isEnrolled) query += `enrolledType=${enrolledType}`;

    return query;
  };

  const filters: Filter[] = [
    {
      label: 'Fecha de emisión',
      type: 'date',
      value: startDate,
      setter: setStartDate,
      dateKey: 'startDate',
    },
    {
      label: 'Fecha de confirmación',
      type: 'date',
      value: endDate,
      setter: setEndDate,
      dateKey: 'endDate',
    },

    {
      label: 'Nombre deudor',
      type: 'autocomplete',
      value: stakeholderName,
      key: 'stakeholderName',
      setter: setStakeholderName,
    },
    {
      label: 'Rut contraparte',
      type: 'text',
      value: stakeholderIdentifier,
      setter: setStakeholderIdentifier,
    },
    {
      label: 'Folio',
      type: 'text',
      value: folio,
      setter: setFolio,
    },
  ];
  if (isEnrolled) {
    filters.push({
      label: 'Tipo de inyección',
      type: 'select',
      options: [
        { value: 'sii', label: 'SII' },
        { value: 'manual', label: 'Creados manualmente' },
      ],
      value: enrolledType,
      setter: setEnrolledType,
    });
  }

  const handleSearchSuggestedDocuments = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    try {
      const query = generateQuery({
        page,
        pageSize,
      });
      const response = await getDocumentsAvailablesForFactoring(
        dispatch,
        business.id,
        subProductSelected,
        query,
      );
      const configuration = response.configuration;
      const documents = response.data;
      const pagination = response.pagination;
      const isEnrolled = response.isEnrolled;
      setConfiguration(configuration);
      setDocuments([...documents]);
      setPagination(pagination);
      setIsEnrolled(isEnrolled);
      setSearchedBySubProduct(true);
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const triggerSearch = async () => {
    setLoading(true);
    const response = await handleSearchSuggestedDocuments({
      page: 0,
      pageSize: PAGE_SIZE,
    });
    setLoading(false);
    return response;
  };

  const setAvailableSubProducts = async () => {
    setLoading(true);
    try {
      const { subProducts, canCreateWithoutCreditLine } =
        await getAvailableSubProductsForFactoring(dispatch, business.id);
      setCreateWithoutCreditline(canCreateWithoutCreditLine);
      setSubProducts(subProducts);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const handleSelectProduct = (id: any) => {
    const subProduct = subProducts.find(
      (subProduct: any) => subProduct.id === id,
    );
    setSubProductSelected(id);
    setSubProduct(subProduct);
    if (searchedBySubProduct) {
      setSearchedBySubProduct(false);
    }
  };

  const handleOpenDialogAdder = () => {
    const subProduct = subProducts.find(
      (subProduct: any) => subProduct.id === subProductSelected,
    );
    if (subProduct.category === 'invoice') {
      setOpenInvoicesAdder(true);
    } else {
      setOpenDocumentAdder(true);
    }
  };
  const handleSetSelected = (selectedIds: any) => {
    const newCachedDocuments = [...cachedDocuments];
    for (const id of selectedIds) {
      const document = documents.find((document: any) => document.id === id);
      if (document) {
        const newCachedIds = [
          ...newCachedDocuments.map((document: any) => document.id),
        ];
        if (!newCachedIds.includes(document.id)) {
          newCachedDocuments.push(document);
        }
      }
    }
    setCachedDocuments(newCachedDocuments);
    setSelected(selectedIds);
  };

  const cantSelectDocuments = (document: any) => {
    if (configuration.showOnlyAvailablesNotInRequest) {
      if (document.requestId) {
        return true;
      }
    }
    if (configuration.dontFilterOwnInvoices) {
      if (document.cessionaryIdentifier === configuration.companyIdentifier) {
        return false;
      }
    }
    if (configuration.showOnlyAvailables) {
      if (
        document.status === 'Transable' ||
        enrolledType === 'manual' ||
        !isEnrolled
      ) {
        return false;
      }
    }
    if (
      !configuration.dontFilterOwnInvoices &&
      !configuration.showOnlyAvailables
    ) {
      return false;
    }
    return true;
  };

  const handleSelectDocuments = async () => {
    setLoading(true);
    const documentselected: any[] = cachedDocuments.filter((document: any) =>
      selected.includes(document.id),
    );
    if (!documentselected) {
      return;
    }
    setLoading(false);
    setSelectedDocuments(documentselected);
    setNewOpenShoppingCart(true);
    setOpen(false);
  };

  const handleSimulationSelect = () => {
    setOpenSimulator(true);
  };

  const handleBackwardsPrefill = async () => {
    setSearched(true);
    setSearchedBySubProduct(true);
    setLoading(true);
    await handleSearchSuggestedDocuments({
      page: pagination.page,
      pageSize: pagination.pageSize,
    });
    setLoading(false);
    await setAvailableSubProducts();
    setSelected(selectedDocuments.map((document: any) => document.id));
    setCachedDocuments(selectedDocuments);
  };

  useEffect(() => {
    if (backwards && !searched) {
      void handleBackwardsPrefill();
    } else if (searched && !backwards) {
      void setAvailableSubProducts();
    }
  }, [searched]);

  const renderCreditNoteAlert = (creditNotesValue: number) => {
    const isWarning = creditNotesValue > 0;
    const alertProps = isWarning
      ? {
          severity: 'warning' as const,
          tooltip: (
            <Box p={1}>
              <Typography fontSize={16}>
                {`Contiene Notas de crédito por: ${formatMoney(creditNotesValue)}`}
              </Typography>
            </Box>
          ),
        }
      : {
          severity: 'success' as const,
          tooltip: (
            <Box p={1}>
              <Typography fontSize={16}>No hay notas de crédito.</Typography>
            </Box>
          ),
        };
    return (
      <LightTooltip title={alertProps.tooltip} placement="top">
        <span>
          <Alert
            severity={alertProps.severity}
            sx={{
              maxWidth: '20px',
              minWidth: '20px',
              height: '20px',
              p: 0,
              m: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '& .MuiAlert-icon': {
                fontSize: '1rem',
                m: 0,
              },
            }}
          />
        </span>
      </LightTooltip>
    );
  };

  return (
    <Dialog open={open} fullWidth maxWidth={searched ? 'xl' : 'sm'}>
      <DialogTitle>
        <HeaderWithActions title="Nueva solicitud" type="dialogHeader" />
      </DialogTitle>
      {loading ? (
        <CenteredCircularProgress type="dialog" />
      ) : (
        <DialogContent>
          {searched ? (
            <div>
              <div
                style={{
                  padding: '10px 0px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body1">
                  <b>Cliente:</b> {business.businessName}
                </Typography>
                <Typography
                  variant="caption"
                  color="primary"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setSearched(false);
                    setSearchedBySubProduct(false);
                    setBackwards(false);
                    setSelectedDocuments([]);
                    setSelected([]);
                  }}
                >
                  Cambiar
                </Typography>
              </div>
              {subProducts.length === 0 ? (
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  padding="8px 0px"
                  color="#E8C547"
                >
                  Este cliente no tiene subproductos disponibles para
                  factorizar. Por favor revise si su línea de crédito está
                  activa
                </Typography>
              ) : (
                <div>
                  <Typography variant="body1">
                    Selecciona un subproducto disponible:
                  </Typography>
                  {createWithoutCreditline && (
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      padding="8px 0px"
                      color="#E8C547"
                    >
                      Este cliente puede no tener una línea de crédito activa
                    </Typography>
                  )}
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={9}>
                      <FormControl margin="dense" fullWidth>
                        <InputLabel id="filter-label">Subproducto</InputLabel>
                        <Select
                          labelId="filter-label"
                          id="Filtrar por estado"
                          fullWidth
                          value={subProductSelected}
                          onChange={(e) => handleSelectProduct(e.target.value)}
                          label="Subproducto"
                        >
                          {subProducts.map((x: any, index: any) => (
                            <MenuItem key={index} value={x.id}>
                              {x.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3} textAlign={'right' as any}>
                      <CustomButton
                        variant="contained"
                        color="primary"
                        onClick={() => triggerSearch()}
                        disabled={!subProductSelected || searchedBySubProduct}
                      >
                        {' '}
                        Ver documentos
                      </CustomButton>
                    </Grid>
                  </Grid>
                </div>
              )}
            </div>
          ) : (
            <div>
              {!isSimulation ? (
                <CompanyBusinessSearcher
                  setBusiness={setBusiness}
                  setSearched={setSearched}
                />
              ) : (
                <div>
                  <Box sx={{ marginBottom: '16px' }}>
                    <ToggleButtonGroup
                      value={activeTab}
                      color="primary"
                      exclusive
                      fullWidth
                      onChange={(_, newValue) => {
                        if (newValue !== null) {
                          setActiveTab(newValue);
                        }
                      }}
                      size="small"
                      sx={{
                        '& .MuiToggleButton-root': {
                          textTransform: 'none',
                          fontWeight: 500,
                        },
                      }}
                    >
                      <ToggleButton value="company">Mis clientes</ToggleButton>
                      <ToggleButton value="rut">Por RUT</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                  {activeTab === 'company' ? (
                    <CompanyBusinessSearcher
                      setBusiness={setBusiness}
                      setSearched={setSearched}
                      onSimulationSelect={handleSimulationSelect}
                    />
                  ) : (
                    <RutBusinessSearcher
                      setBusiness={setBusiness}
                      setSearched={setSearched}
                      onSimulationSelect={handleSimulationSelect}
                    />
                  )}
                </div>
              )}
            </div>
          )}
          {searchedBySubProduct && (
            <div style={{ padding: '20px 0px' }}>
              <Divider />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div>
                  <Typography variant="h6" gutterBottom>
                    Documentos disponibles{' '}
                    {isEnrolled ? '(Conectado SII)' : '(No conectado SII)'}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Estos son los documentos disponibles para factorizar en este
                    subproducto
                  </Typography>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <GlobalSearcher
                    filters={filters}
                    triggerSearch={triggerSearch}
                    dispatch={dispatch}
                    disableSearch={loading}
                  />
                  <CustomButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenDialogAdder()}
                  >
                    {' '}
                    Agregar documentos
                  </CustomButton>
                </div>
              </div>
              <div>
                <TableWithPagination
                  dataHeaders={[
                    { key: 'folio', label: 'Folio' },
                    ...(subProductSelected === 'electronic-invoice'
                      ? [{ key: 'code', label: 'Código' }]
                      : []),
                    ...(documents.some(
                      (doc: any) => doc.creditNoteAmount !== undefined,
                    )
                      ? [
                          {
                            key: 'creditNoteAmount',
                            label: '',
                            type: 'custom',
                            customComponent: (value: any) => {
                              return renderCreditNoteAlert(Number(value) || 0);
                            },
                          },
                        ]
                      : []),
                    { key: 'amount', label: 'Monto', type: 'money' },
                    {
                      key: 'amountAvailable',
                      label: 'Monto disponible',
                      type: 'money',
                    },
                    {
                      key: 'stakeholderName',
                      label: 'Nombre deudor',
                    },
                    {
                      key: 'issuedDate',
                      label: 'Emisión',
                      type: 'eight-days-date',
                    },
                    {
                      key: 'confirmDate',
                      label: 'Confirmación',
                      type: 'date',
                    },
                    {
                      key: 'cancelDate',
                      label: 'Cancelación',
                      type: 'date',
                    },
                    {
                      key: 'creditNoteAmount',
                      label: 'NC',
                      type: 'money',
                    },
                    {
                      key: 'requestId',
                      label: 'Solicitud',
                    },
                    {
                      key: 'status',
                      label: 'Estado SII',
                      type: 'cession',
                    },
                  ]}
                  data={documents}
                  selected={selected}
                  setSelected={handleSetSelected}
                  searchData={handleSearchSuggestedDocuments}
                  setData={setDocuments}
                  pagination={pagination}
                  setPagination={setPagination}
                  loading={loading}
                  setLoading={setLoading}
                  cantSelectRow={cantSelectDocuments}
                />
              </div>
            </div>
          )}
          <DialogActions
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {!searched && (
              <SimulationBanner
                checked={isSimulation}
                onChange={setIsSimulation}
                sx={{ my: 0 }}
              />
            )}
            <CustomButton
              variant="contained"
              color="secondary"
              onClick={() => setOpen(false)}
            >
              {' '}
              Salir
            </CustomButton>
            {searchedBySubProduct && (
              <CustomButton
                variant="contained"
                color="primary"
                disabled={!selected.length}
                onClick={handleSelectDocuments}
              >
                {' '}
                Seleccionar
              </CustomButton>
            )}
          </DialogActions>
        </DialogContent>
      )}
      {openInvoicesAdder && (
        <AddInvoicesManually
          business={business}
          open={openInvoicesAdder}
          isEnrolled={isEnrolled}
          setOpen={setOpenInvoicesAdder}
          subProductSelected={subProductSelected}
          setSuccessOpen={setSuccessOpen}
          handleSearchSuggestedDocuments={handleSearchSuggestedDocuments}
        />
      )}
      {openDocumentAdder && (
        <AddDocumentsManually
          business={business}
          open={openDocumentAdder}
          setOpen={setOpenDocumentAdder}
          subProductSelected={subProductSelected}
          setSuccessOpen={setSuccessOpen}
          handleSearchSuggestedDocuments={handleSearchSuggestedDocuments}
        />
      )}
      <SimulatorDialog
        open={openSimulator}
        setOpen={setOpenSimulator}
        business={business}
        subProduct={subProductSelected}
      />
    </Dialog>
  );
};

export default DocumentsSelectorDialog;
